import { useState } from "react";
import { callsApiService } from "../api/calls";

export function useBulkDownload() {
  const [isBulkDownloading, setIsBulkDownloading] = useState(false);

  const handleBulkDownload = async (selectedRows: { callId: string; fileName: string }[]) => {
    if (!selectedRows.length) return;

    setIsBulkDownloading(true);

    try {
      const selectedCallsInfo = selectedRows.map(({ callId, fileName }) => ({
        callId,
        fileName,
      }));

      const res = await callsApiService.bulkDownloadOutput(selectedCallsInfo);

      if (res.data) {
        const link = document.createElement("a");
        link.href = res.data;
        link.setAttribute("download", "bulk_download.zip");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Failed to generate ZIP file.");
      }
    } catch (error) {
      console.error("Bulk download failed:", error);
    } finally {
      setIsBulkDownloading(false);
    }
  };

  return { isBulkDownloading, handleBulkDownload };
}
